import {
  getDesktopSize,
  getLaptopSize,
  getMobileSize,
  getPosition,
  getTabletLandscapeSize,
  getTabletPortraitSize,
  typeToObjectFitMap
} from "./utils";
import type { ImageProps } from "@bmi-digital/components/media";
import type { Props } from "./types";
import type { Theme } from "@mui/material/styles";

export const createImageProps = (
  imageData: Props,
  theme: Theme
): ImageProps => {
  if ("src" in imageData) {
    return {
      className: imageData.className,
      draggable: false,
      style: {
        objectFit:
          imageData.size || typeToObjectFitMap[imageData.type || "Decorative"]
      },
      decoding: "async",
      loading: imageData.loading,
      src: imageData.src,
      alt: imageData.alt,
      "data-testid": imageData["data-testid"]
    };
  }

  const {
    altText,
    sizes,
    className,
    size,
    type,
    position,
    focalX,
    focalY,
    isMobile,
    loading = "lazy",
    "data-testid": dataTestId
  } = imageData;

  const mobile = getMobileSize(sizes);
  const tabletPortrait = getTabletPortraitSize(sizes);
  const tabletLandscape = getTabletLandscapeSize(sizes);
  const laptop = getLaptopSize(sizes);
  const desktop = getDesktopSize(sizes);

  if (!mobile || !tabletPortrait || !tabletLandscape || !laptop || !desktop) {
    return {
      className: imageData.className,
      draggable: false,
      style: {
        objectFit:
          imageData.size || typeToObjectFitMap[imageData.type || "Decorative"]
      },
      decoding: "async",
      loading: imageData.loading,
      src: imageData.url,
      alt: imageData.altText,
      "data-testid": imageData["data-testid"]
    };
  }

  return {
    className,
    draggable: false,
    style: {
      objectFit: size || typeToObjectFitMap[type || "Decorative"],
      objectPosition: getPosition({
        size,
        position,
        focalX,
        focalY,
        isMobile
      })
    },
    decoding: "async",
    loading: loading,
    src: desktop.url,
    srcSet: `${mobile.url} ${mobile.width}w, ${tabletPortrait.url} ${tabletPortrait.width}w, ${tabletLandscape.url} ${tabletLandscape.width}w, ${laptop.url} ${laptop.width}w, ${desktop.url} ${desktop.width}w`,
    sizes: `(max-width: ${theme.breakpoints.values.sm}px) ${mobile.width}px, (max-width: ${theme.breakpoints.values.md}px) ${tabletPortrait.width}px, (max-width: ${theme.breakpoints.values.lg}px) ${tabletLandscape.width}px, (max-width: ${theme.breakpoints.values.xl}px) ${laptop.width}px, ${desktop.width}px`,
    alt: altText,
    "data-testid": dataTestId
  };
};

export default createImageProps;
